import { MDCFloatingLabel } from "@material/floating-label";
import { MDCTextField } from "@material/textfield";

window.initFloatingLabels = function () {
  let elements = document.querySelectorAll(".mdc-floating-label");
  for (let i = 0; i < elements.length; i++) {
    new MDCFloatingLabel(elements[i]);
  }
  elements = document.querySelectorAll(".mdc-text-field");
  for (let i = 0; i < elements.length; i++) {
    if ($(elements[i]).find(".mdc-text-field__input").length) {
      new MDCTextField(elements[i]);
    }
  }
};

if ($(".mdc-floating-label").length) {
  initFloatingLabels();
}
